function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  height: ", "px;\n  width: ", "px;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Image } from '../Image';
var RandomImage = styled(Image)(_templateObject(), function (props) {
  return props.height;
}, function (props) {
  return props.width;
});

var determineSRC = function determineSRC(blur, chooseSrc, height, width) {
  var imageURLs = ["http://placeimg.com/".concat(width, "/").concat(height, "/any"), "http://placekitten.com/".concat(width, "/").concat(height), "https://picsum.photos/".concat(width, "/").concat(height), "https://source.unsplash.com/".concat(width, "x").concat(height), "https://www.fillmurray.com/".concat(width, "/").concat(height)];

  if (blur || chooseSrc) {
    return blur ? "https://picsum.photos/".concat(width, "/").concat(height, "?blur") : imageURLs[chooseSrc];
  }

  var randomNum = Math.floor(Math.random() * imageURLs.length);
  return imageURLs[randomNum];
};

var PlaceholderImage = function PlaceholderImage(props) {
  // eslint-disable-next-line react/prop-types
  var alt = props.alt,
      ariaHidden = props.ariaHidden,
      blur = props.blur,
      chooseSrc = props.chooseSrc,
      className = props.className,
      height = props.height,
      width = props.width;
  return /*#__PURE__*/React.createElement(RandomImage, {
    alt: alt || 'Random image used for placeholder content',
    "aria-hidden": ariaHidden,
    blur: blur,
    className: className,
    height: height,
    src: determineSRC(blur, chooseSrc, height, width),
    width: width
  });
};

PlaceholderImage.displayName = 'PlaceholderImage';
PlaceholderImage.propTypes = {
  ariaHidden: PropTypes.bool,
  blur: PropTypes.bool,
  chooseSrc: PropTypes.string,
  height: PropTypes.string,
  width: PropTypes.string
};
PlaceholderImage.defaultProps = {
  ariaHidden: true,
  blur: false,
  height: '500',
  width: '500'
};
export default PlaceholderImage;